// extracted by mini-css-extract-plugin
export default {"videos":"Videos_videos__xFv5g","content":"Videos_content__1s5i4","videoWrap":"Videos_videoWrap__JDnWn","videoTitle":"Videos_videoTitle__9ZP+2","video":"Videos_video__y59b7"};